import { render, staticRenderFns } from "./ListDocumentTypesExternals.vue?vue&type=template&id=4c20bfe4&"
import script from "./ListDocumentTypesExternals.vue?vue&type=script&lang=js&"
export * from "./ListDocumentTypesExternals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c20bfe4')) {
      api.createRecord('4c20bfe4', component.options)
    } else {
      api.reload('4c20bfe4', component.options)
    }
    module.hot.accept("./ListDocumentTypesExternals.vue?vue&type=template&id=4c20bfe4&", function () {
      api.rerender('4c20bfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListDocumentTypesExternals.vue"
export default component.exports